import React, { useEffect, useState } from "react";
import CustomButton from "../../components/form/CustomButton";
import { Navigate, useNavigate } from "react-router";
import FiltersPagination from "../../components/elements/FiltersPagination";
import DataTableElement from "../../components/elements/DataTableElement";
import { Columns } from "./Columns";
import ConfirmDeleteModal from "../../components/modal/ConfirmDeleteModal";
import AddUpServiceOrder from "./AddUpServiceOrder";
import { getStatuses, servicesOrderResource } from "../../helpers/configRoutes/backend_helper";
import { useDispatch, useSelector } from "react-redux";
import { update_service, reset_service } from "../../store/serviceOrders/action";
import EvidencesFilesModal from "../Loads/EvidencesFilesModal";
import PreviewPDF from "../../components/modal/PreviewPdf";

const ServiceOrders = () => {
    const dispatch = useDispatch();
    const [filters, setFilters] = useState({ endDate: '', startDate: '', search: '', from: 0, to: 0, page: 1 });
    const [meta, setMeta] = useState({ total: 0, current_page: 0 });
    const [items, setItems] = useState([]);
    const [tableLoad, setTableLoad] = useState({ show: false });
    const [modal, setModal] = useState({ show: false });
    const [modalInvoice, setModalInvoice] = useState({ show: false });
    const [modalConfirm, setModalConfirm] = useState({ show: false, title: 'Delete Truck', loadig: false, textLoad: 'Processing' })
    const [modalFiles, setModalFiles] = useState({ show: false, item: {}, title: 'Show files', });
    const [statusesData, setStatusesData] = useState([])
    const [modalPdf, setModalPdf] = useState({ show: false })

    const openModalAdd = (serviceOrderItem = {}) => {
        dispatch(serviceOrderItem.id ? update_service(serviceOrderItem) : reset_service())
        setModal({
            ...modal,
            show: true,
            title: serviceOrderItem.id ? "Edit Service Order" : "Add Service Order",
        });
    };


    useEffect(() => {
        const getCatalogs = async () => {
            const statusesResponse = await getStatuses({ params: { model: 'ServiceOrder' } })
            if (statusesResponse.status) {
                setStatusesData(statusesResponse.statuses)
            }
        };
        getCatalogs();
    }, []);

    const cols = Columns(openModalAdd, modalConfirm, setModalConfirm, modalFiles, setModalFiles, statusesData, setFilters, filters, setModalPdf);

    useEffect(() => {
        const ServiceOrders = async () => {
            setTableLoad({ show: true })
            try {
                const response = await servicesOrderResource("get", { param: filters });
                setItems(response.serviceOrders);
                setMeta(response.meta)
            } catch (error) {
                console.error("Error fetching service order:", error);
            }
            setTableLoad({ show: false })
        };
        ServiceOrders();
    }, [filters]);

    const deleteServiceOrder = async () => {
        setModalConfirm({ ...modalConfirm, loading: true })
        const response = await servicesOrderResource('del', {}, modalConfirm.id);
        if (response.status) {
            setFilters({ ...filters })
        }
        setModalConfirm({ ...modalConfirm, loading: false, show: false, id: null })
    }

    return (
        <>
            <div className="min-h-screen bg-cs-surface">
                <div className="px-4 md:px-6 py-6 max-w-auto mx-auto">
                    {/* Header */}
                    <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-3 mb-6">
                        <div>
                            <h1 className="text-2xl font-semibold text-cs-dark">Service Orders</h1>
                            <p className="text-sm text-cs-muted mt-1">
                                Manage service to trucks and trailers.
                            </p>
                        </div>

                        <div className="flex flex-col sm:flex-row items-stretch sm:items-center gap-3">
                            {/* Toggle Table / Map */}


                            <div className="px-3 py-1.5 rounded-xl bg-cs-bg border border-cs-border text-[11px] text-cs-muted">
                                Total services orders:{" "}
                                <span className="font-semibold text-cs-dark">
                                    {meta?.total ?? items.length}
                                </span>
                            </div>

                            <CustomButton
                                onClick={() => openModalAdd({})}
                                className="
                                    inline-flex items-center gap-2
                                    px-4 py-2.5
                                    rounded-xl
                                    bg-cs-primary hover:bg-cs-primary-hover
                                    text-white text-sm font-medium
                                    shadow-md hover:shadow-lg
                                    transition-all
                                "
                            >
                                <span className="material-symbols-outlined text-sm">add</span>
                                Create New Service Order
                            </CustomButton>
                        </div>
                    </div>

                    {/* Tabla + filtros / Mapa + filtros */}
                    <div
                        className="
                            bg-cs-bg border border-cs-border rounded-2xl
                            shadow-sm px-2 py-2
                        "
                    >
                        <FiltersPagination showFilters={true} filters={filters} setFilters={setFilters} meta={meta} statusModel={'Settlement'}>
                            <DataTableElement columns={cols} items={items} tableLoad={tableLoad} />
                        </FiltersPagination>
                    </div>
                </div>

            </div>
            {modal.show &&
                <AddUpServiceOrder modal={modal} setModal={setModal} filters={filters} setFilters={setFilters} />
            }
            {modalFiles.show &&
                <EvidencesFilesModal modal={modalFiles} setModal={setModalFiles} filters={filters} setFilters={setFilters} />
            }
            {modalConfirm.show &&
                <ConfirmDeleteModal modal={modalConfirm} setModal={setModalConfirm} action={deleteServiceOrder} />
            }

            {modalPdf.show &&
                <PreviewPDF modal={modalPdf} setModal={setModalPdf} />
            }
        </>
    )
}

export default ServiceOrders;